export const FUNDING_INVOICE_PATH = '/funding-invoice'
